import { type Country, Currency, CountryCurrency } from '@skin-seoul/service';

/**
 * Check if a country requires GDPR cookie consent
 * @param country - The country to check
 * @returns true if the country uses EUR currency (EU countries)
 */
export function doesRequireGDPRConsent(country: Country): boolean {
  const currency = CountryCurrency[country];
  return currency === Currency.Europe;
}
